module.exports = __webpack_public_path__ + "img/logoLogin_epa151617.85e56c49.png";